import { Container, Spinner } from 'reactstrap';
import { RaceBy, Ring } from '@uiball/loaders';

// See https://uiball.com/loaders/

export const Loading = ({
    fullscreen = true,
}: {
    fullscreen?: boolean;
}): any => {
    return (
        <Container
            className={`d-flex ${fullscreen ? 'vh-100' : ''
                } justify-content-center align-items-center`}
        >
            <Spinner
                style={{ width: '0.7rem', height: '0.7rem' }}
                type='grow'
                color='light'
            />
            {/* <h6 className='light ml-4'>Loading</h6> */}
            <RaceBy color='#01aeb4' />
        </Container>
    );
};

export const Uploading = (): any => {
    return <Ring color='#01aeb4' />;
};
